
export function toReadableDateFormat(date) {
    let dateFormat = new Date(date);
    return dateFormat.getDate() + '.' + (dateFormat.getMonth() + 1) + '.' + dateFormat.getFullYear() + " " + dateFormat.getHours() + ":" + dateFormat.getMinutes() + ":" + dateFormat.getSeconds();
}
